import { render, staticRenderFns } from "./AvatarSettings.vue?vue&type=template&id=87046d14&scoped=true&"
import script from "./AvatarSettings.vue?vue&type=script&lang=ts&"
export * from "./AvatarSettings.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarSettings.vue?vue&type=style&index=0&id=87046d14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87046d14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VDialog,VIcon})
